module.exports = __webpack_public_path__ + "img/Expired.8bfd8330.svg";